import React, {useEffect, useState} from 'react';
import {Button, Col, Input, message, Row, Table} from 'antd';
import {EditOutlined, PlusOutlined} from '@ant-design/icons';
import {LocateControllerApi, LocateDto} from "../api";
import EditLocateModal from "../components/modal/EditLocateModal";
import {useKeycloakHeader} from "../config/Config";
import {hasRole, ROLES} from "../components/misc/RolesHelper";
import MissingAuthorizationPage from "./error/MissingAuthorizationPage";
import {useKeycloak} from "@react-keycloak/web";


const LocatorOverview = ({system}) => {
    const {keycloak} = useKeycloak();
    // ParentLocateDtos
    const [locateDtos, setLocateDtos] = useState<LocateDto[]>();
    const [searchText, setSearchText] = useState<string>(''); // Der Suchbegriff

    const [editModalVisible, setEditModalVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<LocateDto>();

    const headers = useKeycloakHeader();
    const locateControllerApi = new LocateControllerApi();

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'System',
            dataIndex: ['system', 'name'],
            key: 'system.name'
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Bearbeiten',
            key: 'edit',
            render: (text, record) => (
                <span>
          <a onClick={() => handleEditClick(record)}>
            <EditOutlined style={{fontSize: '16px', color: '#1890ff'}}/>
          </a>
        </span>
            ),
        }
    ];

    const fetchData = () => {
        locateControllerApi.getLocatesBySystem(system, headers)
            .then((axiosResponse) => {
                const axiosData: Array<LocateDto> = axiosResponse.data;
                setLocateDtos(axiosData);
            })
            .catch((error) => {
                console.error('Fehler beim Abrufen der Daten:', error);
            });
    }

    useEffect(() => {
        fetchData();
    }, [system]);

    // Funktion zum Filtern der Tabelle basierend auf dem Suchbegriff
    const filteredData = locateDtos?.filter((dto) =>
        dto.name?.toLowerCase().includes(searchText.toLowerCase())
    );

    const handleEditCancel = () => {
        setSelectedRecord(undefined);
        setEditModalVisible(false);
    };

    const handleEditSave = (updatedData: LocateDto) => {
        if (!updatedData.id) {
            createNewLocate(updatedData);
        } else {
            updateExistingLocate(updatedData);
        }
        setEditModalVisible(false);
    };

    const createNewLocate = (locate: LocateDto) => {
        locateControllerApi.createLocate(locate, headers).then(response => {
            if (response.status === 200) {
                // Erfolgreiche Antwort
                message.success('Locate erstellt!');
                fetchData();
            } else {
                // Ressource nicht gefunden
                message.error({
                    content: "Locate konnte nicht erstellt werden!",
                    duration: 15
                });
            }
        });
    }

    const updateExistingLocate = (locate: LocateDto) => {
        locateControllerApi.updateLocate(locate, headers).then(response => {
            if (response.status === 200) {
                // Erfolgreiche Antwort
                message.success('Locate aktualisiert!');
                fetchData();
            } else {
                // Ressource nicht gefunden
                message.error({
                    content: "Locate konnte nicht aktualisiert werden!",
                    duration: 15
                });
            }
        });
    }

    const handleEditClick = (record: LocateDto | undefined) => {
        setSelectedRecord(record);
        setEditModalVisible(true);
    };

    let roles = [
        ROLES.GLOW_ADMIN,
        ROLES.GLOW_TEST_DEVELOPER,
        ROLES.GLOW_TEST_DESIGNER
    ];
    const hasRoleForPage = hasRole(roles, keycloak);
    if (!hasRoleForPage) {
        return (<MissingAuthorizationPage roles={roles}/>);
    }

    return (
        <div>
            <h1>Locator</h1>
            <Row>
                {hasRole([ROLES.GLOW_ADMIN, ROLES.GLOW_TEST_DESIGNER, ROLES.GLOW_TEST_DEVELOPER], keycloak) &&
                <Col flex={"70px"}>
                    <Button type="primary" onClick={() => handleEditClick(undefined)}><PlusOutlined/></Button>
                </Col>}
                <Col flex={"auto"}>
                    <Input
                        placeholder="Nach Namen suchen"
                        onChange={(e) => setSearchText(e.target.value)}
                        value={searchText}
                    />
                </Col>
            </Row>

            <Table dataSource={filteredData} columns={columns} locale={{ emptyText: 'Keine Daten vorhanden' }}/>
            <EditLocateModal
                visible={editModalVisible}
                onCancel={handleEditCancel}
                onSave={handleEditSave}
                initialLocateDtoData={selectedRecord}
            />
        </div>
    );
};

export default LocatorOverview;